import { get, find } from 'lodash';

const getScreeningStatus = ({ value, statusEnums } = {}) => {
  const status = find(statusEnums, { value });

  return get(status, 'display_name', '');
};

export default getScreeningStatus;
